import Container from '@/components/global/Container';
import { IComponentBlocksMotorhomeInfoTabs } from '@/graphql/__generated__/global/types';

const MotorhomeInfoTabs = ({ infoTabs }: IComponentBlocksMotorhomeInfoTabs) => {
    return (
        <Container>
            <div className={`grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-${infoTabs?.length} gap-4 justify-items-center`}>
                {infoTabs.map((tab, index) => (
                    <p className="bg-shell opacity-90 p-4 md:p-6 rounded-3xl w-full text-center text-primary h5" key={index}>
                        {tab.highlight}
                    </p>
                ))}
            </div>
        </Container>
    );
};

export default MotorhomeInfoTabs;
